import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Sun, Moon, BarChart2, Zap } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';

export default function Navbar() {
  const { dark, toggle } = useTheme();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <nav className={`navbar${scrolled ? ' scrolled' : ''}`} style={{ zIndex: 500 }}>
      <Link to="/" className="nav-logo">
        <Zap size={16} style={{ color: 'var(--accent)' }} />
        YT <span style={{ opacity: 0.6 }}>|</span> Tahlil
      </Link>
      <div className="nav-right">
        <Link
          to="/analyze"
          style={{
            display: 'flex', alignItems: 'center', gap: 6,
            padding: '9px 20px', borderRadius: 22,
            border: '1px solid rgba(0,212,255,0.35)', color: 'var(--accent-cyan)',
            fontWeight: 600, fontSize: 13, textDecoration: 'none',
            transition: 'all 0.3s',
          }}
          onMouseEnter={e => {
            e.currentTarget.style.background = 'var(--accent-cyan)';
            e.currentTarget.style.color = '#000';
            e.currentTarget.style.boxShadow = '0 0 24px rgba(0,212,255,0.4)';
          }}
          onMouseLeave={e => {
            e.currentTarget.style.background = 'transparent';
            e.currentTarget.style.color = 'var(--accent-cyan)';
            e.currentTarget.style.boxShadow = 'none';
          }}
        >
          <BarChart2 size={14} />
          Kanal tahlili
        </Link>
        <button className="theme-btn" onClick={toggle} aria-label="Mavzuni o'zgartirish">
          <span className={`theme-icon ${dark ? 'active' : ''}`}><Moon size={15} /></span>
          <span className={`theme-icon ${!dark ? 'active' : ''}`}><Sun size={15} /></span>
        </button>
      </div>
    </nav>
  );
}
